<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-10 10:04:51
 * @LastEditors: xgx
 * @LastEditTime: 2023-06-07 17:36:37
-->
<template>
  <div>
    <el-drawer
      title="运行记录详情"
      :visible.sync="visibleTwo"
      @closed="closeTwo"
      :destroy-on-close="true"
      size="600px"
      :with-header="true"
    >
      <a-spin :spinning="loading">
        <div>
          <div class="applay-box">
            <div>
              <div class="title">
                <div class="icon-title"></div>
                <div class="title-txt">稿件信息</div>
              </div>
              <div class="txt-box">
                <div class="txt">提交人</div>
                <div class="txt-two">
                  {{ recordData.createUserName }}
                </div>
              </div>
              <div class="txt-box">
                <div class="txt">提交时间</div>
                <div class="txt-two">
                  {{ recordData.createTime }}
                </div>
              </div>

              <div class="txt-box">
                <div class="txt">所属组织</div>
                <div class="txt-two">
                  <div
                    style="margin-bottom: 5px"
                    v-for="item in recordData.orgName"
                  >
                    {{ item }}
                  </div>
                </div>
              </div>
              <div class="txt-box">
                <div class="txt">稿件名称</div>
                <div class="txt-two">{{ recordData.title }}</div>
              </div>
              <div class="txt-box">
                <div class="txt">关联栏目</div>
                <div class="txt-two">
                  <div
                    style="margin-bottom: 5px"
                    v-for="item in recordData.columnName"
                  >
                    {{ item }}
                  </div>
                </div>
              </div>
            </div>
            <div style="margin-top: 30px">
              <div class="title">
                <div class="icon-title"></div>
                <div class="title-txt">工作流信息</div>
              </div>
              <div class="txt-box">
                <div class="txt">工作流</div>
                <div class="txt-two">{{ recordData.procdefName }}</div>
              </div>
              <div class="txt-box">
                <div class="txt">当前状态</div>
                <div class="txt-two">
                  {{ recordData.finished ? "已结束" : "审核中" }}
                </div>
              </div>
              <div class="txt-box">
                <div class="txt">当前节点</div>
                <div class="txt-two">{{ recordData.nowNode }}</div>
              </div>
              <div v-for="(item, index) in recordData.auditNode" class="txt-box">
                <div class="txt">审核 {{ index + 1 }}</div>
                <div class="txt-two">
                  <div
                    style="margin-bottom: 5px"
                    v-for="itemTwo in item.split('\n')"
                  >
                    {{ itemTwo }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </a-spin>
    </el-drawer>
  </div>
</template>

<script>
import { runningRecordInfo } from "./custom_variables";
export default {
  data() {
    return {
      visibleTwo: false,
      recordData: {},
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    itemData: {
      type: Object,
      default: {},
    },
  },
  components: {},
  mounted() {},
  methods: {
    closeTwo() {
      this.$emit("closeTwo");
    },
    getData() {
      this.loading = true;
      runningRecordInfo({
        id: this.itemData.id,
      }).then((res) => {
        if (res.code == 0) {
          this.recordData = res.data;
        }
        this.loading = false;
      });
    },
  },
  created() {},
  watch: {
    visible(val) {
      this.visibleTwo = val;
      if (val) {
        this.getData();
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-drawer__header {
  border-bottom: solid 2px #ededef;
  padding-bottom: 16px;
  color: #000;
  font-size: 18px;
  font-weight: 600;
}
/deep/ .el-drawer {
  border-top-left-radius: 13px;
  border-bottom-left-radius: 13px;
}
/deep/ .el-icon-close {
  font-weight: 600;
}
.demo-ruleForm {
  padding-right: 24px;
}
/deep/ .el-select {
  width: 100%;
}
/deep/ .el-form-item__label {
  text-align: left;
  padding-left: 22px;
}
.remard {
  text-indent: 10px;
}
/deep/ input::-webkit-input-placeholder {
  color: #415058;
}
/deep/ .ant-select-selection__placeholder {
  color: #415058;
}
.bottom {
  text-align: right;
  position: absolute;
  bottom: 0;
  height: 84px;
  border-top: solid 2px #e5e7ec;
  width: 100%;
  background: #fff;
  .form-bottom {
    margin-top: 19px;
    margin-right: 24px;
  }
}
/deep/ .el-select .el-input .el-select__caret {
  color: #000;
}
.top {
  padding: 24px;
  padding-right: 0px;
  padding-top: 0px;
}
.log-box {
  border-bottom: solid 1px #dcdfe6;
  display: flex;
  color: #000;
  .log {
    padding: 10px 20px;
    border-top: solid 1px #dcdfe6;
    border-left: solid 1px #dcdfe6;
    cursor: pointer;
  }
  .log:last-child {
    border-right: solid 1px #dcdfe6;
  }
}
.head {
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #dcdfe6;
  padding: 18px 24px;
}
.back {
  cursor: pointer;
}
/deep/ .el-form-item {
  margin-bottom: 0px;
}
/deep/ .el-dialog__title {
  font-weight: 600;
}
/deep/ .el-dialog__close {
  font-weight: 600;
  color: #000;
}
.colum-title-box {
  height: 34px;
  line-height: 34px;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding-left: 12px;
  color: rgba(144, 147, 153, 1);
  margin-bottom: 20px;
}
.demo-ruleForm-two {
  /deep/ .el-form-item {
    margin-bottom: 20px;
  }
}
/*下拉框选择树*/
.objectTree {
  position: absolute;
  overflow: auto;
  z-index: 100;
  height: 200px;
  border: 1px solid #ddd;
  line-height: normal;
  z-index: 204;
  margin-left: 100px;
  width: 397px;
}
/deep/ .el-tree-node__expand-icon {
  font-size: 14px;
  font-weight: 600;
}
.icon {
  position: absolute;
  right: 9px;
  top: 15px;
}
.demo-ruleForm-three {
  height: 300px;
  /deep/ .el-form-item {
    margin-bottom: 30px;
  }
}
.applay-box {
  padding: 24px;
  padding-top: 0px;
  padding-bottom: 100px;
}
.title {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  .icon-title {
    width: 4px;
    height: 18px;
    border-radius: 2px;
    background-color: rgba(23, 109, 230, 1);
  }
  .title-txt {
    color: rgba(23, 109, 230, 1);
    font-size: 16px;
    font-family: HarmonyOS_Sans_SC-regular;
    margin-left: 10px;
    font-weight: 600;
  }
}
.txt {
  color: rgba(48, 49, 51, 1);
  font-size: 14px;
  font-family: HarmonyOS_Sans_SC-bold;
  font-weight: 600;
  width: 80px;
}
.txt-two {
  color: rgba(48, 49, 51, 1);
  font-size: 14px;
  font-family: HarmonyOS_Sans_SC-regular;
  width: 100%;
}
.txt-box {
  margin-bottom: 20px;
  display: flex;
}
.txt-two-img {
  width: 120px;
  height: 120px;
  margin-right: 14px;
  background: #f6f6f6;
  /deep/ .el-image__inner {
    object-fit: contain;
  }
}
</style>